import { useEffect } from "react";
import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import RocketToTop from "./components/feature/RocketToTop";
import { prefetchRoutes } from "./router/prefetch";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";

function App() {
  useEffect(() => {
    prefetchRoutes();
  }, []);

  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <AppRoutes />
        <RocketToTop />
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;
